import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class IsInIframeService {
    public isInIframe(): boolean {
        return window.self !== window.top;
    }
}